import React from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import useAuthStore from '../hooks/useAuth';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: '📊', end: true },
  { to: '/admin/kunden', label: 'Kunden', icon: '🏢' },
  { to: '/admin/logs', label: 'Logs', icon: '📋' },
  { to: '/admin/anmeldeprotokoll', label: 'Anmeldeprotokoll', icon: '🔐' },
];

export default function AdminLayout() {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <aside className="w-56 bg-gray-900 text-white flex flex-col">
        <div className="p-4 border-b border-gray-700">
          <div>
            {/* Weißer Chip hinter dem Logo: der Schriftzug enthält dunkles
                Navy, das auf dem dunklen Sidebar-Hintergrund sonst kaum
                lesbar wäre. */}
            <div className="bg-white rounded-lg px-3 py-3">
              <img src="/logo-wide.png" alt="IncoMail" className="w-full h-auto object-contain" />
            </div>
            <div className="text-xs text-gray-400 mt-1.5">Superadmin</div>
          </div>
        </div>
        <nav className="flex-1 p-3 space-y-1">
          {navItems.map(({ to, label, icon, end }) => (
            <NavLink key={to} to={to} end={end}
              className={({ isActive }) =>
                `flex items-center gap-3 px-3 py-2 rounded-lg text-sm transition-colors ${
                  isActive ? 'bg-blue-600 text-white' : 'text-gray-300 hover:bg-gray-800'
                }`
              }
            >
              <span>{icon}</span>{label}
            </NavLink>
          ))}
        </nav>
        <div className="p-3 border-t border-gray-700">
          <div className="text-xs text-gray-400 mb-2 px-2 truncate">{user?.email}</div>
          <button onClick={handleLogout}
            className="w-full px-3 py-2 text-sm text-gray-300 hover:text-white hover:bg-gray-800 rounded-lg text-left transition-colors">
            Abmelden
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 overflow-auto">
        <Outlet />
      </main>
    </div>
  );
}
